// client/src/components/SuggestionsDialog.js

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Checkbox,
  VStack,
  Text,
  Box,
  Spinner,
  HStack,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';

export default function SuggestionsDialog({
  isOpen,
  onClose,
  suggestions,
  onConfirm,
  initialSelected = [],
  isLoading = false,
  errorMessage = '',
  onRetry,
}) {
  const [checkedItems, setCheckedItems] = useState([]);

  useEffect(() => {
    if (isOpen) {
      setCheckedItems(initialSelected);
    }
  }, [isOpen, initialSelected]);

  const suggestionKeys = Object.keys(suggestions || {});
  const hasNoSuggestions = suggestionKeys.length === 0;

  const handleCheckboxChange = (key, isChecked) => {
    if (isChecked) {
      setCheckedItems(prev => [...prev, key]);
    } else {
      setCheckedItems(prev => prev.filter(item => item !== key));
    }
  };

  const handleConfirm = () => {
    onConfirm(checkedItems);
  };

  const handleClear = () => {
    setCheckedItems([]);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent alignSelf="center">
        <ModalHeader>Review and approve suggestions for your report</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {isLoading ? (
            <VStack spacing={4} py={8}>
              <Spinner size="lg" color="#037A9B" />
              <Text fontSize="14px" color="gray.600">
                Extracting optimization suggestions...
              </Text>
            </VStack>
          ) : errorMessage ? (
            <VStack spacing={4} align="stretch" py={4}>
              <Box
                border="1px solid"
                borderColor="red.200"
                bg="red.50"
                borderRadius="12px"
                p={4}
              >
                <Text fontSize="14px" color="red.600">
                  {errorMessage}
                </Text>
              </Box>

              <HStack justify="flex-end">
                <Button variant="ghost" onClick={onClose}>
                  Close
                </Button>
                <Button
                  bg="#037A9B"
                  color="white"
                  _hover={{ bg: '#026781' }}
                  onClick={onRetry}
                >
                  Retry
                </Button>
              </HStack>
            </VStack>
          ) : hasNoSuggestions ? (
            <Text color="#6D6D6D" textAlign="center" py={20}>
              No suggestions found
            </Text>
          ) : (
            <VStack align="stretch" spacing={4}>
              {suggestionKeys.map((key) => (
                <Box key={key} p={3} border="1px solid #DADADA" borderRadius="md">
                  <Checkbox
                    colorScheme="pink"
                    borderColor="#C4C4C4"
                    isChecked={checkedItems.includes(key)}
                    onChange={(e) => handleCheckboxChange(key, e.target.checked)}
                    mb={2}
                  >
                    <Text fontWeight="semibold" color="#242424">{key}</Text>
                  </Checkbox>
                  <Text fontSize="sm" color="#6D6D6D" ml={6}>
                    {suggestions[key]}
                  </Text>
                </Box>
              ))}
            </VStack>
          )}
        </ModalBody>

        <ModalFooter>
          {!isLoading && !errorMessage && !hasNoSuggestions && (
            <>
              <Button
                mr={3}
                bg="#FFFFFF"
                color="#037A9B"
                border="1px solid #00C2E5"
                borderRadius="12px"
                fontWeight="600"
                _hover={{ bg: '#FFFFFF' }}
                _active={{ bg: '#FFFFFF' }}
                onClick={handleClear}
              >
                Clear
              </Button>

              <Button
                colorScheme="blue"
                bg="#CF008A"
                color="#FFFFFF"
                borderRadius="12px"
                _hover={{ bg: '#CF008A' }}
                _active={{ bg: '#CF008A' }}
                onClick={handleConfirm}
              // isDisabled={checkedItems.length === 0 || hasNoSuggestions}
              >
                Generate Report
                {checkedItems.length > 0 && ` (${checkedItems.length})`}
              </Button>
            </>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}